import React, { useState } from 'react';
import { supabase } from '../../lib/supabase';
import { ACC, MUT, BRD, SURF, TXT, inp, sel, txa, btnA, btnG, col, dvdr, sm, ovly, mdl, mdlH, mdlB, mdlF } from '../../lib/styles';
import { SVC_CATEGORIES } from '../../lib/constants';
import { FL } from './shared';
import { mIcon, nowL, uid } from '../../lib/helpers';
import { toLocalInputValue, localInputToISO } from '../../lib/dates';
import { toastError } from '../../lib/toast';
import { uploadPhoto, deletePhoto } from '../../lib/storage';
import PhotoAdder from './PhotoAdder';
// ── Service Modal ─────────────────────────────────────────────────────────────
function ServiceModal({machine,existing,onSave,onClose}){
  const e=existing||{};
  // DB values are full ISO+offset strings — convert to local datetime-local format
  const [ca,setCa]=useState(toLocalInputValue(e.completedAt)||nowL());
  const [types,setTy]=useState(e.types||[]);
  const [notes,setNo]=useState(e.notes||"");
  const [pp,setPp]=useState(e.plugPhoto||null);
  const [jp,setJp]=useState(e.jobPhotos||[]);
  const [pb,setPb]=useState(false);
  const [saving,setSaving]=useState(false);
  // Photos replaced/removed during this edit — only deleted from storage after
  // a successful save, so Cancel never breaks an already-persisted record.
  const removedPhotos=React.useRef([]);
  const [openCats,setOpenCats]=useState({general:true});
  const tog=t=>setTy(prev=>prev.includes(t)?prev.filter(x=>x!==t):[...prev,t]);
  const togCat=id=>setOpenCats(prev=>({...prev,[id]:!prev[id]}));
  const handlePlug=async ev=>{
    const f=ev.target.files[0];if(!f)return;setPb(true);
    try{
      const newUrl=await uploadPhoto(f);
      if(pp)removedPhotos.current.push(pp);
      setPp(newUrl);
    }catch(err){
      console.error("plug photo upload:",err);
      toastError("Photo upload failed — try again");
    }
    setPb(false);
  };
  const save=async()=>{
    if(saving)return;
    const iso=localInputToISO(ca);
    if(!iso){toastError("Enter a completed date/time");return;}
    setSaving(true);
    try{
      await onSave({id:e.id||uid(),completedAt:iso,types:types.length?types:["General Service"],
        notes:notes.trim(),plugPhoto:pp,jobPhotos:jp,
        createdAt:e.createdAt||new Date().toISOString(),updatedAt:new Date().toISOString()});
      removedPhotos.current.forEach(url=>deletePhoto(url));
    }catch(err){
      console.error("service save:",err);
      toastError(err?.message||"Save failed — check connection and try again");
      setSaving(false);
    }
  };

  const mType = machine.type||"";
  const sType = machine.strokeType||"";

  const visibleCats = SVC_CATEGORIES.filter(cat=>cat.show(mType,sType));

  return (
    <div style={ovly} onClick={onClose}>
      <div style={mdl} onClick={ev=>ev.stopPropagation()}>
        <div style={mdlH}>
          <b style={{fontSize:14,textTransform:"uppercase"}}>{existing?"Edit Entry":"Log Service"}</b>
          <button style={{...btnG,...sm}} onClick={onClose}>✕</button>
        </div>
        <div style={mdlB}>
          <div style={{fontSize:11,color:MUT,marginBottom:10}}>{mIcon(machine.type)} {machine.name}</div>
          <div style={col}><FL t="Completed" /><input type="datetime-local" style={inp} value={ca} onChange={ev=>setCa(ev.target.value)} /></div>

          {types.length>0&&<div style={{marginBottom:10,padding:"8px 10px",background:"#0d0d0d",border:"1px solid "+BRD,borderRadius:2}}>
            <div style={{fontSize:10,color:MUT,letterSpacing:"0.1em",textTransform:"uppercase",marginBottom:6}}>Selected ({types.length})</div>
            <div style={{display:"flex",flexWrap:"wrap",gap:4}}>
              {types.map(t=><span key={t} onClick={()=>tog(t)} style={{fontSize:10,fontWeight:700,padding:"2px 7px",borderRadius:2,cursor:"pointer",fontFamily:"'IBM Plex Mono',monospace",textTransform:"uppercase",background:"#2a1200",border:"1px solid "+ACC,color:ACC}}>✕ {t}</span>)}
            </div>
          </div>}

          <FL t="Work Done" />
          <div style={{marginBottom:12}}>
            {visibleCats.map(cat=>{
              const items = typeof cat.items==="function" ? cat.items(mType,sType) : cat.items;
              if(!items||items.length===0) return null;
              const catSelected = items.filter(i=>types.includes(i)).length;
              const isOpen = openCats[cat.id];
              return (
                <div key={cat.id} style={{marginBottom:4,border:"1px solid "+(catSelected>0?ACC+"44":BRD),borderRadius:2,overflow:"hidden"}}>
                  <div onClick={()=>togCat(cat.id)} style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"8px 10px",cursor:"pointer",background:catSelected>0?"#1a0a00":"#0a0a0a",userSelect:"none"}}>
                    <span style={{fontSize:9,fontWeight:700,letterSpacing:"0.1em",textTransform:"uppercase",color:catSelected>0?ACC:MUT}}>{cat.label}{catSelected>0&&<span style={{marginLeft:6,fontSize:10,background:ACC,color:"#fff",borderRadius:2,padding:"1px 5px"}}>{catSelected}</span>}</span>
                    <span style={{color:MUT,fontSize:11}}>{isOpen?"▲":"▼"}</span>
                  </div>
                  {isOpen&&<div style={{padding:"8px 10px",display:"flex",flexWrap:"wrap",gap:5,borderTop:"1px solid "+BRD}}>
                    {items.map(t=>(
                      <button key={t} onClick={()=>tog(t)} style={{fontSize:9,fontWeight:600,padding:"4px 8px",borderRadius:2,cursor:"pointer",fontFamily:"'IBM Plex Mono',monospace",textTransform:"uppercase",background:types.includes(t)?"#2a1200":"none",border:types.includes(t)?"1px solid "+ACC:"1px solid "+BRD,color:types.includes(t)?ACC:MUT}}>
                        {t}
                      </button>
                    ))}
                  </div>}
                </div>
              );
            })}
          </div>

          <div style={col}><FL t="Notes" /><textarea style={txa} placeholder="What was found, done, part numbers..." value={notes} onChange={ev=>setNo(ev.target.value)} /></div>
          {sType!=="Electric"&&sType!=="Diesel"&&<div style={col}>
            <FL t="Spark Plug Photo" />
            {pp&&<img src={pp} alt="" style={{width:"100%",maxHeight:120,objectFit:"cover",borderRadius:2,marginBottom:6}} />}
            {pb?<div style={{fontSize:9,color:MUT,textAlign:"center",padding:"8px 0"}}>Processing...</div>:
            <div style={{display:"flex",gap:6}} onClick={ev=>ev.stopPropagation()}>
              <input id="plugCam" type="file" accept="image/*" capture="environment" onChange={handlePlug} style={{display:"none"}} />
              <input id="plugGal" type="file" accept="image/*" onChange={handlePlug} style={{display:"none"}} />
              <button onClick={()=>document.getElementById("plugCam").click()} style={{...btnG,flex:1,fontSize:9,padding:"8px 0"}}>📷 Camera</button>
              <button onClick={()=>document.getElementById("plugGal").click()} style={{...btnG,flex:1,fontSize:9,padding:"8px 0"}}>🖼 Gallery</button>
            </div>}
            {pp&&<button style={{...btnG,...sm,marginTop:5}} onClick={()=>{removedPhotos.current.push(pp);setPp(null);}}>Remove</button>}
          </div>}
          <PhotoAdder photos={jp} setPhotos={setJp} label="Job Photos" />
        </div>
        <div style={mdlF}>
          <button style={btnG} onClick={onClose}>Cancel</button>
          <button style={{...btnA,opacity:saving?0.5:1}} disabled={saving} onClick={save}>{existing?"Save Changes":"Save Entry"}</button>
        </div>
      </div>
    </div>
  );
}

export default ServiceModal;